import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    name: {
        backgroundColor: '#8d8d8f'
    },

}